export default async function dataLayerListener() {
  await new Promise(resolve => window.setTimeout(resolve, 10));
  if (!window.dataLayer) return;

  const originalPush = window.dataLayer.push;
  window.dataLayer.push = function(...args) {
    if (!args) return;

    const pushEvent = new CustomEvent('datalayerpush', {
      detail: args,
    });

    window.dispatchEvent(pushEvent);

    try {
      if (originalPush && args) originalPush(...args);
    } catch (err) {}
  };
}
